import { useEffect, useState } from 'react'
import blockUser from '@hotmart/app-legal-block'
import { useSelector } from 'store/redux.store'

import { getTosFeature } from 'src/app/routes/preroutes.services'
import { getParamsTos } from 'src/app/routes/preroutes.utils'

type UseTosProps = {
  isCheckingToken: boolean
}

export const useTos = ({ isCheckingToken }: UseTosProps) => {
  const { user } = useSelector(state => state)
  const [isFetchingTosFeatureToggle, setIsFetchingTosFeatureToggle] = useState(false)

  useEffect(() => {
    if (!isCheckingToken && user && user?.hasSignupRole && !isFetchingTosFeatureToggle) {
      const fetchTosFeatureToggle = async () => {
        try {
          const response = await getTosFeature()

          if (response) {
            const canUseTosApiV2 = response.ALLOW_USE_API_TOS_V2
            const params = getParamsTos(user?.language, canUseTosApiV2)

            blockUser(params)
          }
        } catch (error) {
          console.error('BW: Failed fetching TOS feature toggle', error)
        }
      }

      fetchTosFeatureToggle()
      setIsFetchingTosFeatureToggle(true)
    }
  }, [isCheckingToken, user, isFetchingTosFeatureToggle])
}
